module.exports = __webpack_public_path__ + "static/3-5c5aa25747e329a14d9ab8be881cbe02.woff";